import React, { useState, createContext, Dispatch, SetStateAction } from 'react';

interface ComponentStateContextProps {
  guestsDeleted: number;
  setGuestsDeleted: Dispatch<SetStateAction<number>>;
  editForm: { type: string; id?: string } | null;
  setEditForm: Dispatch<SetStateAction<any>>;
}

const ComponentStateContext = createContext({} as ComponentStateContextProps);

export const ComponentStateProvider: React.FC<{}> = ({ children }) => {
  const [guestsDeleted, setGuestsDeleted] = useState(0);
  const [editForm, setEditForm] = React.useState(null);

  return (
    <ComponentStateContext.Provider
      value={{
        guestsDeleted,
        setGuestsDeleted,
        editForm,
        setEditForm,
      }}
    >
      {children}
    </ComponentStateContext.Provider>
  );
};

export default ComponentStateContext;
